var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThemesdefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9048 10.258L11.6315 1L1.66271 10.9524C1.23793 11.385 1 11.9667 1 12.5725C1 13.1784 1.23793 13.76 1.66271 14.1927L7.69034 20.2104C8.61767 21.1362 10.0087 21.1362 10.936 20.2104L20.9048 10.258Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4603 12.5722L11.5635 12.5722L3.61905 12.5234H1C1 13.1293 1.23793 13.7597 1.66271 14.1923L7.69034 20.2101C8.61767 21.1359 10.0087 21.1359 10.936 20.2101L18.4603 12.5722Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 20.8469C22.9998 21.418 22.7699 21.9658 22.3606 22.3696C21.9513 22.7735 21.3962 23.0004 20.8173 23.0004C20.2385 23.0004 19.6833 22.7735 19.274 22.3696C18.8647 21.9658 18.6348 21.418 18.6348 20.8469C18.6348 19.1242 20.4899 18.2628 20.8173 16.54C21.1447 18.2628 22.9998 19.1242 22.9998 20.8469Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemesdefault);
export default __webpack_public_path__ + "static/media/themes default.c86c58deb194ce029d76c1acb2de6c94.svg";
export { ForwardRef as ReactComponent };